// The one way a ported `<a href download>` crosses into the Bearer world:
// an authenticated fetch → blob (api/client `downloadFile`). An anchor cannot
// carry the Authorization or org headers, so every export button goes through
// here instead of an href (PLATFORM_INTEGRATION §9).
import { Download } from 'lucide-react'
import { useState } from 'react'

import { ApiError, downloadFile } from '../api/client'
import { Btn } from './Modal'
import { showToast } from './toast'

export function DownloadButton({ path, label, disabled, icon = false }: {
  /** an api path (`/runs/…/export?format=xlsx`) or the absolute href
   *  `reportLinks` builds — `downloadFile` accepts both */
  path: string
  label: string
  disabled?: boolean
  icon?: boolean
}) {
  const [busy, setBusy] = useState(false)
  return (
    <Btn
      size="xs"
      disabled={disabled}
      loading={busy}
      onClick={() => {
        setBusy(true)
        downloadFile(path)
          .catch((e) =>
            showToast({
              color: 'red',
              title: 'Download failed',
              message: e instanceof ApiError ? e.message : String(e),
            }),
          )
          .finally(() => setBusy(false))
      }}
    >
      {icon && <Download size={13} />}
      {label}
    </Btn>
  )
}
